module.exports = __webpack_public_path__ + "static/media/about-bg-1.57397fb0.png";